// 任务配置
export default {
    siteManagement: 'управление сайтом',
    siteName: 'Название сайта',
    addSite: 'добавить сайт',
    tip_enterSiteName: 'Пожалуйста, введите название сайта',
}